import { createContext, useContext } from 'react';
import Logger from 'src/utils/logger.utils';
export var Theme;
(function (Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
})(Theme || (Theme = {}));
export var ThemeOpacity;
(function (ThemeOpacity) {
    ThemeOpacity["dark"] = "33";
    ThemeOpacity["light"] = "2b";
})(ThemeOpacity || (ThemeOpacity = {}));
export const ThemeContext = createContext({
    theme: Theme.DARK,
    setTheme: (theme) => {
        Logger.log('no theme provider');
    },
    toggleTheme: () => {
        Logger.log('no theme provider');
    },
});
export const useThemeContext = () => useContext(ThemeContext);
